module.exports = __webpack_public_path__ + "img/ctrl-sqrt-swap-stub-mid-+.03eef9d7.svg";